<template>
  <v-content class="view-container">
    <v-app-bar
      color="transparent"
      flat
    >
      <img
        width="75"
        src="../assets/logo_mini_2.png"
        @click="$router.replace('/')"
      >
      <v-spacer />
      <v-toolbar-title class="primary--text page-title font-weight-bold">
        {{ $t('password.resetPassword') }}
      </v-toolbar-title>
      <v-spacer />
    </v-app-bar>
    <v-container>
      <v-row>
        <v-col
          xl="6"
          offset-xl="3"
          md="8"
          offset-md="2"
        >
          <edit-password-form
            :class="{'mt-4 pa-3': !$mobileDetect.phone(), 'pa-2': $mobileDetect.phone()}"
            :old-password-needed="false"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>
<script>
  export default {
    name: 'Password',
    components: {
      EditPasswordForm: () => import('../components/Account/EditPasswordForm'),
    },
  }
</script>
<style scoped>
img {
  cursor: pointer
}
@media screen and (min-width: 25em){
  .page-title { font-size: calc( 16px + (24 - 16) * (100vw - 400px) / (800 - 400) ); }
}
</style>
